export const exceptionEnglish = {
  TITLE: 'Exception inbox',
  DESCRIPTION:
    'Find failed messages and attachments, follow up, and track confirmed recovery.',
  REFRESH: 'Refresh',
  LOADING: 'Loading exceptions…',
  LOAD_ERROR: 'Unable to load exceptions. Please refresh and try again.',
  SAVE_ERROR:
    'Unable to update this exception. Refresh its latest status and try again.',
  FILTER_STATUS: 'Handling status',
  FILTER_CATEGORY: 'Exception type',
  FILTER_INBOX: 'Inbox',
  FILTER_ASSIGNEE: 'Conversation assignee',
  FILTER_HISTORY: 'Source',
  ALL_CATEGORIES: 'All types',
  ALL_INBOXES: 'All accessible inboxes',
  ALL_ASSIGNEES: 'All assignees',
  MINE: 'Assigned to me',
  UNASSIGNED: 'Unassigned',
  LIVE_ONLY: 'Live messages',
  HISTORY_ONLY: 'Imported history only',
  ALL_SOURCES: 'All sources',
  HISTORY_TAG: 'Imported history',
  AFTER: 'Last occurred · from',
  BEFORE: 'Last occurred · through',
  COUNTS: '{conversations} conversations · {cases} exceptions',
  UPDATED: 'Updated {time}',
  EMPTY: 'No matching exceptions',
  EMPTY_HINT: 'Switch to Ignored or Recovered to view other exceptions.',
  PAGINATION: 'Exception pages',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  PAGE: '{page} / {total}',
  RECOVERY_NOTE:
    'Recovery follows confirmed delivery or successful attachment retrieval. Closing a conversation or requesting a retry does not resolve an exception. Updates appear automatically about once a minute.',
  CONVERSATION: 'Conversation #{id}',
  CONVERSATION_RESOLVED: 'Conversation resolved',
  INBOX_VALUE: 'Inbox: {name}',
  ASSIGNEE_VALUE: 'Assignee: {name}',
  FIRST: 'First observed: {time}',
  LAST: 'Last changed: {time}',
  EXPAND: 'View {count} exceptions',
  COLLAPSE: 'Collapse',
  LOAD_MORE: 'Load more exceptions',
  LOCATE_MESSAGE: 'Locate message #{id}',
  HANDLER: 'Handled by: {name}',
  ATTEMPTS: 'Delivery attempts: {count}',
  RECOVERED_AT: 'Recovered: {time}',
  HANDLING_NOTE: 'Handling note: {note}',
  RECONCILE: 'Check delivery',
  SAFE_RETRY: 'Check and safely retry',
  DELIVERY_DETAILS: 'Delivery details',
  CLAIM: 'Start handling',
  CONFIRM_NO_ISSUE: 'Confirm no issue',
  NO_ISSUE_NOTE: 'Manually confirmed: no issue; no further action required.',
  IGNORE: 'Ignore',
  REOPEN: 'Return to pending',
  IGNORE_REASON: 'Reason for ignoring (required)',
  IGNORE_PLACEHOLDER: 'For example: customer provided the attachment again.',
  IGNORE_NOTE:
    'Ignored exceptions remain in the history and are not marked recovered.',
  CANCEL: 'Cancel',
  CONFIRM_IGNORE: 'Confirm ignore',
  OPERATION_QUEUED:
    'Request submitted. Recovery will update after confirmation from the channel.',
  OPERATION_ERROR:
    'No confirmed result. Open delivery details and check the current status before trying again.',
  MEDIA_RECOVERY_HINT:
    'Automatic retrieval may still be running. This attachment currently has no manual retrieval action. Open the message and ask the customer to resend it if needed; successful retrieval moves this exception to Recovered.',
  HANDLING_HISTORY: 'Handling history',
  HANDLING_ACTOR: 'Agent #{id}',
  ERROR_CODE: 'Reason code: {code}',
  STATE: {
    active: 'Unresolved',
    open: 'Pending',
    in_progress: 'In progress',
    ignored: 'Ignored',
    recovered: 'Recovered',
    all: 'All statuses',
  },
  CATEGORY: {
    send_failed: 'Send failed',
    delivery_uncertain: 'Delivery needs checking',
    waha_media_failed: 'WAHA attachment unavailable',
  },
  CATEGORY_HINT: {
    send_failed:
      'The channel reported a send failure. Open the original message for details.',
    delivery_uncertain:
      'The delivery result is unconfirmed. Check existing receipts before resending.',
    waha_media_failed:
      'This attachment has not been retrieved successfully. Open the original message to review it.',
  },
  REASON: {
    expired_link: 'The attachment download link has expired.',
    timeout: 'The attachment download timed out and has not succeeded yet.',
    missing_reference:
      'The information required to download this attachment is missing.',
    size_limit: 'The attachment exceeds the channel size limit.',
    storage_full: 'Server storage is full; the attachment was not saved.',
    invalid_video: 'The received video failed validation.',
    media_unavailable: 'The attachment is currently unavailable.',
    provider_rejected: 'The channel rejected this message.',
    outcome_unknown:
      'The channel did not return a definite result. Check delivery before resending.',
    no_safe_retry:
      'An existing send attempt prevents a duplicate send. Check delivery first.',
    pending_parts:
      'Some parts of this message have no confirmed delivery result.',
    delivery_acceptance_mismatch:
      'The email delivery confirmation does not match the stored message. An administrator must check it.',
    mapping_missing: 'The original channel message mapping is missing.',
    ambiguous_mapping:
      'Multiple channel messages match this record. An administrator must check it.',
  },
};

export const exceptionChinese = {
  TITLE: '异常清单',
  DESCRIPTION: '集中查看发送和附件异常，定位消息并跟踪处理结果。',
  REFRESH: '刷新',
  LOADING: '正在加载异常…',
  LOAD_ERROR: '异常清单加载失败，请刷新重试。',
  SAVE_ERROR: '处理状态更新失败，请刷新最新状态后重试。',
  FILTER_STATUS: '处理状态',
  FILTER_CATEGORY: '异常类型',
  FILTER_INBOX: '收件箱',
  FILTER_ASSIGNEE: '会话负责人',
  FILTER_HISTORY: '消息来源',
  ALL_CATEGORIES: '全部类型',
  ALL_INBOXES: '全部可访问收件箱',
  ALL_ASSIGNEES: '全部负责人',
  MINE: '仅看我负责的',
  UNASSIGNED: '未分配',
  LIVE_ONLY: '当前消息',
  HISTORY_ONLY: '仅历史导入',
  ALL_SOURCES: '全部来源',
  HISTORY_TAG: '历史导入',
  AFTER: '最近发生 · 开始日期',
  BEFORE: '最近发生 · 结束日期',
  COUNTS: '{conversations} 个会话 · {cases} 项异常',
  UPDATED: '更新于 {time}',
  EMPTY: '没有符合条件的异常',
  EMPTY_HINT: '可切换到“已忽略”或“已恢复”查看其他异常。',
  PAGINATION: '异常清单分页',
  PREVIOUS: '上一页',
  NEXT: '下一页',
  PAGE: '第 {page} / {total} 页',
  RECOVERY_NOTE:
    '发送确认成功或附件获取成功后，异常自动转为已恢复。关闭会话或提交重试不会直接解决异常。清单约每分钟自动更新一次。',
  CONVERSATION: '会话 #{id}',
  CONVERSATION_RESOLVED: '会话已解决',
  INBOX_VALUE: '收件箱：{name}',
  ASSIGNEE_VALUE: '负责人：{name}',
  FIRST: '首次发现：{time}',
  LAST: '最近变化：{time}',
  EXPAND: '查看 {count} 项异常',
  COLLAPSE: '收起异常',
  LOAD_MORE: '加载更多异常',
  LOCATE_MESSAGE: '定位消息 #{id}',
  HANDLER: '处理人：{name}',
  ATTEMPTS: '发送尝试：{count} 次',
  RECOVERED_AT: '恢复时间：{time}',
  HANDLING_NOTE: '处理备注：{note}',
  RECONCILE: '核对投递状态',
  SAFE_RETRY: '检查并安全重试',
  DELIVERY_DETAILS: '投递详情',
  CLAIM: '开始处理',
  CONFIRM_NO_ISSUE: '确认异常无问题',
  NO_ISSUE_NOTE: '人工确认：该异常无问题，无需继续处理。',
  IGNORE: '忽略',
  REOPEN: '重新待处理',
  IGNORE_REASON: '忽略原因（必填）',
  IGNORE_PLACEHOLDER: '例如：客户已重新发送附件。',
  IGNORE_NOTE: '忽略后保留处理记录，不会标记为已恢复。',
  CANCEL: '取消',
  CONFIRM_IGNORE: '确认忽略',
  OPERATION_QUEUED: '已提交，等待渠道确认；确认恢复后会自动更新状态。',
  OPERATION_ERROR: '未取得明确结果，请打开投递详情核对当前状态，避免重复发送。',
  MEDIA_RECOVERY_HINT:
    '后台可能仍在尝试获取，此附件目前不支持手动重取。可定位原消息，必要时请客户重新发送；原附件获取成功后自动移入“已恢复”。',
  HANDLING_HISTORY: '处理记录',
  HANDLING_ACTOR: '客服 #{id}',
  ERROR_CODE: '原因代码：{code}',
  STATE: {
    active: '未解决',
    open: '待处理',
    in_progress: '处理中',
    ignored: '已忽略',
    recovered: '已恢复',
    all: '全部状态',
  },
  CATEGORY: {
    send_failed: '发送失败',
    delivery_uncertain: '投递待核对',
    waha_media_failed: 'WAHA 附件获取异常',
  },
  CATEGORY_HINT: {
    send_failed: '渠道报告发送失败，可定位原消息查看详情。',
    delivery_uncertain:
      '尚无可靠的投递结果，请先核对已有回执，再决定是否重发。',
    waha_media_failed: '附件尚未成功获取，可定位原消息核查。',
  },
  REASON: {
    expired_link: '附件下载链接已失效。',
    timeout: '附件下载超时，目前尚未成功获取。',
    missing_reference: '缺少获取此附件所需的下载信息。',
    size_limit: '附件超过通道大小限制。',
    storage_full: '服务器存储空间不足，附件未能保存。',
    invalid_video: '收到的视频未通过内容校验。',
    media_unavailable: '附件目前暂不可用。',
    provider_rejected: '渠道未接受本次发送。',
    outcome_unknown: '渠道未返回明确结果，请核对投递状态后再决定是否重发。',
    no_safe_retry: '已有发送尝试，系统已阻止重复发送，请先核对投递状态。',
    pending_parts: '部分消息仍缺少明确的投递结果。',
    delivery_acceptance_mismatch:
      '邮件投递确认与已保存消息不一致，需要管理员核查。',
    mapping_missing: '原始渠道消息映射缺失。',
    ambiguous_mapping: '存在多条渠道消息映射，需要管理员核查。',
  },
};
